import {
  ADD_EDUCATION,
  ADD_EDUCATION_FAILURE,
  ADD_EDUCATION_SUCCESS,
  EDIT_EDUCATION,
  EDIT_EDUCATION_FAILURE,
  EDIT_EDUCATION_SUCCESS,
} from '../Actiontype';

export const AddEducation = data => ({
  payload: data,
  type: ADD_EDUCATION,
});
export const AddEducationSuccess = response => ({
  payload: response,
  type: ADD_EDUCATION_SUCCESS,
});
export const AddEducationFailure = response => ({
  payload: response,
  type: ADD_EDUCATION_FAILURE,
});
export const EditEducation = data => ({
  payload: data,
  type: EDIT_EDUCATION,
});
export const EditEducationSuccess = response => ({
  payload: response,
  type: EDIT_EDUCATION_SUCCESS,
});
export const EditEducationFailure = response => ({
  payload: response,
  type: EDIT_EDUCATION_FAILURE,
});
